import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-envio-simple-stepper',
  templateUrl: './envio-simple-stepper.component.html',
  styleUrls: ['./envio-simple-stepper.component.css']
})
export class EnvioSimpleStepperComponent {
  @Input() elementos: string[] = [];
  @Input() stepActive = '';

  private get activeIndex(): number {
    return this.elementos.indexOf(this.stepActive);
  }

  /** Ultimo paso activo: circuito cerrado (tick verde), como finalizarProceso del wizard de documento. */
  private get circuitoCerrado(): boolean {
    return this.activeIndex >= 0 && this.activeIndex === this.elementos.length - 1;
  }

  getItemClass(index: number): string {
    if (this.isComplete(index)) return 'is-complete';
    if (index === this.activeIndex) return 'is-active';
    return 'is-pending';
  }

  getDotClass(index: number): string {
    if (this.isComplete(index)) return 'step-done';
    if (index === this.activeIndex) return 'step-active';
    return '';
  }

  isComplete(index: number): boolean {
    if (this.activeIndex < 0) {
      return false;
    }
    if (this.circuitoCerrado) {
      return index <= this.activeIndex;
    }
    return index < this.activeIndex;
  }

  getLineClass(index: number): string {
    if (this.activeIndex < 0) {
      return '';
    }
    if (this.circuitoCerrado || index < this.activeIndex) {
      return 'step-active-line';
    }
    return '';
  }
}